import React from 'react';
import { Link } from 'react-router-dom';
import "./ServicesCard.scss";

type AppProps = {
  serviceTitle: string;
  url: string;
  comingSoon?: boolean;
}

const ServicesCard = ({
  serviceTitle,
  url,
  comingSoon
}: AppProps) => {
  return (
    <div className={`col-4 service-box mt-4`}>
      <div className={`service-card h-100 ${ comingSoon && 'services-coming-soon-wrap' }`}>
        <Link className="d-block p-5" to={url}>
          <h4 className="text-white text-left font-slick" style={{ fontSize: '30px' }}>
            {serviceTitle}
          </h4>
          <span style={{
            position: 'absolute',
            bottom: '0',
            right: '0',
            display: 'inline-block',
            opacity: '0.4'
          }}>
            {/* <IconSearch /> */}
          </span>
        </Link>
        {comingSoon && <div className="coming-soon">Coming Soon</div>}
      </div>
    </div >
  )
}

export default ServicesCard;